import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@shared/guards';

const routes: Routes = [
    { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule), canLoad: [AuthGuard] },
    {
        path: 'silverfin-redirect',
        loadChildren: () => import('./silverfin-redirect/silverfin-redirect.module').then((m) => m.SilverfinRedirectModule),
        canLoad: [AuthGuard],
    },
    { path: 'user-content', loadChildren: () => import('./external-access/external-access.module').then((m) => m.ExternalAccessModule) },
    // Route that can be used to test error monitoring
    { path: 'tests/sentry-error', redirectTo: AuthGuard as unknown as string, canLoad: [AuthGuard] },
    // Other test routes
    { path: 'tests', loadChildren: () => import('./tests/tests.module').then((m) => m.TestsModule), canLoad: [AuthGuard] },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
